import type { Guard } from '@wellyes/react-router-extended';
import { HttpService } from '@core/services';
import { UserHttpService } from '@core/services/http';
import { requestWithStoreWaiting } from '@core/utils/methods';
import store from '@store/index';
import { getRoleReportKeys } from './reports-access';

export class ReportsGuard implements Guard {
  async canActivate(): Promise<boolean> {
    if (!Object.keys(store.getState().user.activeUser).length) {
      await requestWithStoreWaiting(
        () => HttpService.getHttpRequests(UserHttpService).getSelf(),
        () => store.getState().user,
      );
    }

    return getRoleReportKeys(store.getState().user.activeUser.roles).length > 0;
  }
}
